// extracted by mini-css-extract-plugin
module.exports = {"Component":"CustomerOverview_Component__2GGJX"};